import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import React from 'react';
import { useHistory } from 'react-router-dom';
import useLocale from '@/utils/useLocale';
import locale from '../locale'; // LESS

import styles from './style/register.module.less'; // API

import { ApiGetEmailCode } from '@/api';
import { ApiReset } from '@/api';
const FormItem = _Form.Item;

const Forgot = () => {
  const t = useLocale(locale);
  const history = useHistory();

  const [form] = _Form.useForm(); // 获取验证码按钮状态


  const [disableBtn, setDisableBtn] = React.useState(false);
  const [btnInfo, setBtnInfo] = React.useState(t['register.form.send']);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['login-wrap']
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("h4", {
    className: styles['title']
  }, t['forgot.form.title']), /*#__PURE__*/React.createElement(_Form, {
    form: form,
    wrapperCol: {
      span: 24
    },
    autoComplete: "off",
    onValuesChange: (v, vs) => {
      console.log(v, vs);
    },
    onSubmit: v => {
      // console.log(v);
      // Message.success('success');
      ApiReset(v).then(req => {
        _Message.success(t['auth.message.restPasswordSuccess']);

        history.push('/');
      });
    }
  }, /*#__PURE__*/React.createElement(FormItem, {
    field: "email",
    rules: [{
      required: true,
      message: t['register.form.email.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    height: 40,
    placeholder: t['auth.email']
  })), /*#__PURE__*/React.createElement(_Space, {
    style: {
      justifyContent: 'space-between'
    },
    size: 'small'
  }, /*#__PURE__*/React.createElement(FormItem, {
    field: "code",
    rules: [{
      required: true,
      message: t['register.form.code.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    height: 40,
    style: {
      width: 286
    },
    placeholder: t['auth.code']
  })), /*#__PURE__*/React.createElement(FormItem, null, /*#__PURE__*/React.createElement(_Button, {
    disabled: disableBtn,
    style: {
      height: 40,
      width: 102
    },
    type: "secondary",
    onClick: async () => {
      try {
        await form.validate(['email']); // 重试

        setDisableBtn(true);
        setBtnInfo(30 + t['register.form.retry']);
        let timetotal = 30;
        const timeInterval = setInterval(() => {
          timetotal = timetotal - 1;

          if (timetotal < 1) {
            clearInterval(timeInterval);
            setDisableBtn(false);
            setBtnInfo(t['register.form.send']);
            return;
          }

          setBtnInfo(timetotal + t['register.form.retry']);
        }, 1000);
        const params = {
          email: form.getFieldsValue().email,
          type: 'resetPassword'
        };
        ApiGetEmailCode(params).then(res => {
          if (res.data.code === 0) {
            _Message.success(t['register.form.code.success']);
          } else {
            _Message.error(t['register.form.code.success']);
          }
        });
      } catch (e) {
        _Message.error(t['register.form.emailCheck.errMsg']);
      }
    }
  }, btnInfo))), /*#__PURE__*/React.createElement(FormItem, {
    field: "password",
    rules: [{
      required: true,
      message: t['register.form.password']
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    height: 40,
    placeholder: t['auth.newPassword']
  })), /*#__PURE__*/React.createElement(FormItem, null, /*#__PURE__*/React.createElement(_Space, {
    direction: "vertical",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(_Button, {
    style: {
      height: 40
    },
    type: "primary",
    htmlType: "submit",
    long: true
  }, t['auth.confirm']), /*#__PURE__*/React.createElement(_Button, {
    style: {
      height: 40
    },
    type: "text",
    href: "/login",
    long: true
  }, t['auth.return']))))));
};

export default Forgot;